<template>
    <div class="recipe-item-line d-flex align-items-center">
        <select class="form-control mr-1" v-model="selectedItem" required>
            <optgroup label="Produits">
                <option v-for="item in productItems" :value="{type: 'product', sku: item.sku}">{{ item.sku }} - {{ item.name }}</option>
            </optgroup>
            <optgroup label="Composants">
                <option v-for="item in componentItems" :value="{type: 'component', sku: item.sku, unit_name: item.unit_name}">{{ item.sku }} - {{ item.name }}</option>
            </optgroup>
        </select>
        <input ref="hiddenFieldType" type="hidden" :name="fieldName + '[type]'">
        <input ref="hiddenFieldSku" type="hidden" :name="fieldName + '[sku]'">
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text" :id="fieldId + '-prepend'">Quantité</span>
            </div>
            <InputIntegerPositive class="form-control" :name="fieldName + '[quantity]'" :id="fieldId + '-quantity'" :aria-describedby="fieldId + '-prepend'" v-model="quantity" required />
            <div class="input-group-append">
                <span class="input-group-text">{{ (selectedItem && selectedItem.unit_name) || 'unité' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import InputIntegerPositive from "../InputIntegerPositive"

    export default {
        name: 'RecipeItemLine',

        components: {
            InputIntegerPositive,
        },

        props: {
            fieldId: {
                type: String,
                required: true,
            },
            fieldName: {
                type: String,
                required: true,
            },
            items: {
                type: Array,
                required: true,
            },
            value: {
                type: Object,
                required: false,
            },
        },

        data() {
            let selectedItem = null;
            let quantity = 1;
            if (this.value) {
                const itemFound = this.items.find((item) => {
                    return item.sku === this.value.sku;
                })
                if (itemFound) {
                    selectedItem = {
                        type: itemFound.recipe_item_type,
                        sku: itemFound.sku,
                    };
                    if (typeof itemFound.unit_name !== 'undefined') {
                        selectedItem.unit_name = itemFound.unit_name;
                    }
                    quantity = this.value.quantity;
                }
            }

            return {
                selectedItem: selectedItem,
                quantity: quantity,
            }
        },

        mounted() {
            this.syncHiddenFields();
        },

        watch: {
            selectedItem() {
                if (this.selectedItem) {
                    this.syncHiddenFields();

                    this.$emit('change', {
                        type: this.selectedItem.type,
                        sku: this.selectedItem.sku,
                        quantity: this.quantity,
                    });
                } else {
                    this.$emit('change', null);
                }
            },
        },

        methods: {
            syncHiddenFields() {
                if (this.selectedItem) {
                    this.$refs.hiddenFieldType.value = this.selectedItem.type;
                    this.$refs.hiddenFieldSku.value = this.selectedItem.sku;
                } else {
                    this.$refs.hiddenFieldType.value = null;
                    this.$refs.hiddenFieldSku.value = null;
                }
            },
        },

        computed: {
            productItems() {
                return this.items.filter((item) => {
                    return item.recipe_item_type === 'product';
                });
            },

            componentItems() {
                return this.items.filter((item) => {
                    return item.recipe_item_type === 'component';
                });
            },
        }
    }
</script>

<style scoped lang="scss">
</style>
